// extracted by mini-css-extract-plugin
export default {"infoPageContent":"InfoPage_infoPageContent__1Zdnv","buttons":"InfoPage_buttons__sFjNm"};